import React from 'react'

import { Box, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useAtomValue, useSetAtom } from 'jotai'

import { useAccount } from 'wagmi'
import TokenLogo from '../common/TokenLogo'
import { TargetChainAtom, TickerAtom } from '../common/atoms'
import EvmBalance from './EvmBalance'
import BtcBalance from './BtcBalance'
import { TICKERS_FILTER_BY_CHAIN } from '@/constants/token'
import { useBtc } from '@/context/BtcContext'

const TokenList = ({
  mode,
  onSelect,
  searchInput,
}: {
  mode: 'btc' | 'evm'
  onSelect: () => void
  searchInput: string
}) => {
  const setTicker = useSetAtom(TickerAtom)
  const targetChain = useAtomValue(TargetChainAtom)

  const tickersSupportedOnTargetChain = TICKERS_FILTER_BY_CHAIN[targetChain]

  const filteredTickers = tickersSupportedOnTargetChain.filter(
    (ticker) =>
      ticker.erc20Tokens?.[targetChain].symbol.toLowerCase().includes(searchInput.trim().toLowerCase()) ||
      ticker.erc20Tokens?.[targetChain].address.toLowerCase().includes(searchInput.trim().toLowerCase()),
  )

  const { address: btcAccount } = useBtc()
  const { address: evmAccount } = useAccount()

  if (filteredTickers.length <= 0) {
    return (
      <Box sx={{ height: { xs: 234, md: 340 }, display: 'grid', placeItems: 'center' }}>
        <Typography fontSize={30}>No results found</Typography>
      </Box>
    )
  }

  return (
    <List sx={{ py: 0, overflow: 'auto', maxHeight: { xs: 234, md: 340 } }}>
      {filteredTickers.map((ticker) => (
        <ListItem
          key={ticker.erc20Tokens?.[targetChain].symbol}
          disablePadding
          onClick={() => {
            setTicker(ticker.name)
            onSelect()
          }}
        >
          <ListItemButton sx={{ py: 12 }}>
            <TokenLogo
              alt={ticker.erc20Tokens?.[targetChain].symbol}
              src={mode === 'evm' && ticker.logoSrcSet?.erc ? ticker.logoSrcSet.erc : ticker.logoSrcSet.brc}
              size={24}
            />
            <ListItemText sx={{ ml: 8 }} primary={ticker.erc20Tokens?.[targetChain].symbol} />

            {!!evmAccount && mode === 'evm' && <EvmBalance tickerName={ticker.name} />}
            {!!btcAccount && mode === 'btc' && <BtcBalance tickerName={ticker.name} />}
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )
}

export default TokenList
